import { render, staticRenderFns } from "./StuenglishTable.vue?vue&type=template&id=3a8cef39&scoped=true&"
import script from "./StuenglishTable.vue?vue&type=script&lang=js&"
export * from "./StuenglishTable.vue?vue&type=script&lang=js&"
import style0 from "./StuenglishTable.vue?vue&type=style&index=0&id=3a8cef39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cef39",
  null
  
)

export default component.exports